$(document).ready(
    function () {

        let p = $("body").attr("p");
        let a = $("body").attr("a");
        if (p === 'organizer_promo_code_product' && a === 'list') {

            let promo_code_product_register_ajax_lock = false;

            $(document).on("click", "#promo-code-product-register-button", function () {
                let promoCodeId = parseInt($(this).attr('data-promo-code-id'));
                let productId = parseInt($("select[name='product_id'] option:selected").val());
                let priceInclVat = parseFloat($("input[name='price_incl_vat']").val());
                let altPriceInclVat = parseFloat($("input[name='alt_price_incl_vat']").val());
                let locationId = parseInt($("body").attr("event_id"));

                if (!promo_code_product_register_ajax_lock) {

                    promo_code_product_register_ajax_lock = true;

                    $.ajax({
                        type: 'POST',
                        url: "/ajax/organizer_promo_code_product/new",
                        data: {
                            promo_code_id: promoCodeId,
                            product_id: productId,
                            location_id: locationId,
                            price_incl_vat: priceInclVat,
                            alt_price_incl_vat: altPriceInclVat,
                        }
                    })
                        .done(function (data) {

                            if (data.html !== undefined && data.html !== null) {
                                $("select[name='product_id'] option:selected").remove();
                                $('#promo-code-product-list-sortable').empty();
                                $('#promo-code-product-list-sortable').append(data.html);
                                $("#price_incl_vat").val(null);
                                $("#alt_price_incl_vat").val(null);
                                popupAlert();
                            }

                        })
                        .fail(function (data) {

                            if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                                document.location.href = data.responseJSON.redirect_url;
                            }

                            promo_code_product_register_ajax_lock = false;

                        }).always(function () {
                        promo_code_product_register_ajax_lock = false;
                    });

                }

            });


        }

    }
);